"use client";

import dynamic from "next/dynamic";
import { useState, useCallback } from "react";

const DynamicChatWidget = dynamic(() => import("./chat-widget").then(mod => mod.ChatWidget), { ssr: false });

export function LazyChatWidget() {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = useCallback(() => {
    setIsOpen(true);
  }, []);

  return (
    <>
      {/* Static FAB (pure CSS, no JS chunk until clicked) */}
      {!isOpen && (
        <button
          onClick={handleOpen}
          aria-label="Open chat"
          className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full shadow-lg transition-all duration-300 bg-gradient-to-br from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 hover:shadow-xl hover:shadow-blue-500/25 hover:scale-110 active:scale-95 flex items-center justify-center text-white group cursor-pointer"
          style={{ direction: "ltr" }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="w-6 h-6 transition-transform group-hover:scale-110"
          >
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
          </svg>
          <span className="absolute inset-0 rounded-full bg-gradient-to-br from-blue-500 to-purple-600 animate-ping opacity-20" aria-hidden />
        </button>
      )}
      {isOpen && <DynamicChatWidget />}
    </>
  );
}